import React, { useContext } from 'react';
import { Grid, Icon, Dropdown, List,  Ref } from 'semantic-ui-react';

import { ButtonLink, EllipsisDropdown, LinkedAccount, Table } from 'dyl-components';
import { Link } from 'react-router-dom';
import {  StatusDropdown } from 'pages/Accounts/subcomponents/ConversionControls';
import { FormsContext } from 'pages/Accounts/subcomponents/FormsProvider';
import Forms from 'pages/Accounts/subcomponents/Forms';



const DropdownItem = ({ text, icon, ...otherProps }) => {
    return (
        <Dropdown.Item text={<React.Fragment>
            <Icon name={icon} />
            {text}
        </React.Fragment>}
            style={{ cursor: 'pointer' }}
            {...otherProps}
        />
    );
}

export const Account = ({
    name,
    id,

    primary_contact,
    counts,
    pinned,
    readLinkedAccounts,
    customer,
    master_account_id
}) => {
    const { contact_count, lead_count, opportunity_count } = counts
    const { onStatusDropdownSelect, onLinkSelect, onUnlinkSelect } = useContext(FormsContext)
    const actionPopupRef = React.createRef();
    const ELLIPSIS_OPTIONS = [
        {
            id: 1,
            text: 'Change Master Account',
            icon: 'fa-solid fa-buildings',
            onClick: (e,id,master_id)=>{
                onLinkSelect(id,master_id);
            } 
        },
        {
            id:2,
            text: 'Unlink Master Account',
            icon: 'fas fa-diagram-nested',
            onClick: (e,id,master_id)=>{
                onUnlinkSelect(actionPopupRef,{account_id: id ,master_account:master_id});
            } 
        }
    ];
    return (
        <React.Fragment>
            <Forms readAccounts={readLinkedAccounts} />

    <Table.Row>
        <Table.Cell>
            {pinned && <Icon color='primary' link className='fas thumbtack' />}
        </Table.Cell>
        <Table.Cell>
            <LinkedAccount
                account={name}
                maxWidth={'9em'}
                subtitle={id && `ID: ${id}`}
                popup
                linkToAccount={<Link target={'_blank'} to={`/account/${id}`}>{name}</Link>}
            />
        </Table.Cell>
        <Table.Cell>
            {primary_contact?.id && (
                <Grid columns='equal' verticalAlign='middle'>
                    <Grid.Column>
                        <LinkedAccount
                            maxWidth={'9em'}
                            account={`${primary_contact.first_name} ${primary_contact.last_name}`}
                            subtitle={primary_contact.primary_email?.email}
                            linkToAccount={<Link target={'_blank'} to={`/contact/${primary_contact.id}`}>{primary_contact.first_name} {primary_contact.last_name}</Link>}
                        />
                    </Grid.Column>
                    <Grid.Column>
                        <Icon disabled={!primary_contact.primary_phone} link color='primary' className='fas fa-phone' />
                        <Icon disabled={!primary_contact.primary_phone} link color='primary' className='fas fa-comment' />
                        <Icon disabled={!primary_contact.primary_email} link color='primary' className='fas fa-envelope' />
                    </Grid.Column>
                </Grid>
            )}
        </Table.Cell>
        <Table.Cell>
            <List>
                <List.Item>
                    <ButtonLink>{contact_count || 0} contact{contact_count > 1 && 's'}</ButtonLink>
                </List.Item>
                <List.Item>
                    <ButtonLink>{lead_count || 0} lead{lead_count > 1 && 's'}</ButtonLink>
                </List.Item>
                <List.Item>
                    <ButtonLink>{opportunity_count || 0} {opportunity_count > 1 ? 'opportunities' : 'opportunity'}</ButtonLink>
                </List.Item>
            </List>
        </Table.Cell>
        <Table.Cell>
                    {customer.customer_fund_type !== "unfunded" && <StatusDropdown
                        account={{
                            ...customer,
                            account_status: customer.customer_status,
                            id: id,
                            fund_type: customer.customer_fund_type
                        }}
                        onStatusDropdownSelect={onStatusDropdownSelect}
                    />}
                </Table.Cell>
        <Table.Cell>
            <EllipsisDropdown>
                        {ELLIPSIS_OPTIONS.map(({ text, icon, ...otherProps }, idx) => {
                            return (
                                <Ref innerRef={actionPopupRef}>
                                    <DropdownItem
                                        key={idx}
                                        text={text}
                                        icon={icon}
                                        {...otherProps}
                                        onClick={
                                            (e) => {
                                                otherProps.onClick(e, id, master_account_id);
                                            }
                                        }
                                    />
                                </Ref>
                            );
                        })}
            </EllipsisDropdown>
        </Table.Cell>
    </Table.Row>
        </React.Fragment>
)}
